import { Button } from 'components/common';
import { EditIcon } from 'components/common/Icons';
import { DeleteIcon } from 'components/common/Icons/DeleteIcon';
import { FC } from 'react';
import { IAddressProps } from './types';

export const Address: FC<IAddressProps> = ({ address, startDate, onDelete, onEdit }) => {
  return (
    <div className={'flex flex-col items-center justify-between rounded-xl py-10 px-5 shadow-md'}>
      <div className={'flex flex-col items-center'}>
        <h3 className={'mt-0 text-center text-xl'}>{address}</h3>
        <p className={'mt-0 text-base text-gray-500'}>{startDate}</p>
      </div>
      <div className={'flex'}>
        <Button size={'large'} color={'error'} variant={'text'} onClick={onDelete}>
          <DeleteIcon htmlColor={'grey'} />
        </Button>
        <Button size={'large'} color={'info'} variant={'text'} onClick={onEdit}>
          <EditIcon htmlColor={'grey'} />
        </Button>
      </div>
    </div>
  );
};
